const DEFAULT_SEQUENCE_DWELL_MS = 5000;

export function resolveSequencedDwellMs(dwellMs?: number): number {
  return dwellMs ?? DEFAULT_SEQUENCE_DWELL_MS;
}
